import type { Chip } from "../core/chip";
import { ChipMap } from "../chipmap/ChipMap";
import { GamebookChipMap } from "../chipmap/GamebookChipMap";
import type { LayoutPosition } from "../gamebook/projection/projectChips";

type Props = {
  chips: Chip[];
  activeChipId: string;
  onSelectChip: (chipId: string) => void;
  mode?: "demo" | "gamebook";
  positions?: Record<string, LayoutPosition>;
};

export function ChipMapScreen(props: Props) {
  const mode = props.mode ?? "demo";
  return (
    <section class="map-wrap">
      {mode === "gamebook" && props.positions ? (
        <GamebookChipMap
          chips={props.chips}
          activeChipId={props.activeChipId}
          positions={props.positions}
          onSelectChip={props.onSelectChip}
        />
      ) : (
        <ChipMap
          chips={props.chips}
          activeChipId={props.activeChipId}
          onSelectChip={props.onSelectChip}
        />
      )}
    </section>
  );
}
